import { getTimeTillEndOfDayMs } from '@helpers';
import { FetchQueryOptions } from '@tanstack/react-query';
import { getEntityValues } from '@terminal/services/get-entity-values/getEntityValues';
import { queryClient } from '@terminal/services/query-client/queryClient';
import { useFlags } from '@terminal/stores/use-flags/useFlags';
import { mapEntityValues } from '@terminal/stores/use-watchlist/mapEntityValues';
import { WatchlistEntities } from '@terminal/stores/use-watchlist/watchlist-types';

export const WATCHLIST_ENTITY_QUERY_KEY = 'watchlist_entity';

export const fetchWatchlistEntityQuery = (tag: string) => {
  const isApiScreenerEntitiesV3FlagEnabled = useFlags
    .getState()
    .getFeatureFlagState('DATA-1243-api_screener_entities_v3');

  return queryClient.fetchQuery(
    createQueryOptions(tag, isApiScreenerEntitiesV3FlagEnabled)
  );
};

export const createQueryOptions = (
  tag: string,
  isApiScreenerEntitiesV3FlagEnabled: boolean
): FetchQueryOptions<WatchlistEntities | null> => ({
  queryKey: [
    WATCHLIST_ENTITY_QUERY_KEY,
    tag,
    isApiScreenerEntitiesV3FlagEnabled,
  ],
  queryFn: async () => {
    const res = await getEntityValues(tag, isApiScreenerEntitiesV3FlagEnabled);

    if (!res) {
      return null;
    }

    if (!res.snakeMeta) {
      return null;
    }

    const mapped = mapEntityValues({
      entities: [{ tag }],
      ...res,
      tag,
    });

    return mapped[0];
  },
  staleTime: getTimeTillEndOfDayMs(),
});
